jQuery(document).ready(function($){
  var Shopify = Shopify || {};
  Shopify.money_format = "${{amount}}";

  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
      
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  $(window).on('scroll', function(){
      if ($(window).scrollTop() > 60){
          $('body').addClass('float_active');
      }else {
          $('body').removeClass('float_active');
      }
  });

  $(document).on('click', '#menu_trigger', function(event){
      event.preventDefault();
   
      if($('body').hasClass('menu_open')){
          $('body').removeClass('menu_open');
      }else{
          $('body').addClass('menu_open');
      }
  });

  $('.smooth_scroll').click(function(event){
  	event.preventDefault();
  	var margintop = $(this).data('mtop') ? $(this).data('mtop') : 60;
  	
  	if($(this.hash).length > 0){
  		$('html,body').animate({scrollTop:$(this.hash).offset().top - margintop}, 1200);
  	}else{
  		var getUrl = window.location,
  			url = getUrl .protocol +'//'+ getUrl.host +'/'+this.hash;
  		window.location = url;
  	}
  });

  //mobile_menu_overlay
   $(document).on('click', '#mobile_menu_overlay', function(event){
      $('body').removeClass('menu_open');
  });

  const testimonials_carousel = new Swiper('.testimonials_carousel', {
      pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
      },
      breakpoints: {
          0: {
              slidesPerView: 1,
              spaceBetween: 20
          },
          992: {
              slidesPerView: 3,
              spaceBetween: 20
          }
      }
  });

  const corporate_testimonials_carousel = new Swiper('.corporate_testimonials_carousel', {
      pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
      },
      breakpoints: {
          0: {
              slidesPerView: 1.4,
              spaceBetween: 10
          },
          992: {
              slidesPerView: 3.2,
              spaceBetween: 10
          }
      }
  });

  // Initialise EVERY colorway gallery (not just the first), each with its own
  // scoped navigation, so variant galleries — which include the shared images —
  // actually slide. observer/observeParents lets a gallery recalc when it's shown.
  document.querySelectorAll('.product_gallery_slider').forEach(function(el){
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: el.querySelector('.product_gallery_nav_next'),
        prevEl: el.querySelector('.product_gallery_nav_prev'),
      },
    });
  });
  
  const gallery_carousel = new Swiper('.gallery_carousel', {
      centeredSlides: true,
      initialSlide:2,
      spaceBetween: 15,
      loop:true,
      autoplay: {
          delay: 5000,
      },
      navigation: {
          prevEl: '.gallery_carousel_prev',
          nextEl: '.gallery_carousel_next',
      },
      breakpoints: {
          0: {
              slidesPerView: 1.5,
          },
          992: {
              slidesPerView: 3.4,
          }
      }
  });

  //data-thumb
  $(document).on('click', '[data-thumb]', function(event){
    var idx = $(this).data('thumb'),
        slider = $(this).data('slider');

    $('.gallery_thumbnails_wrapper .product_gallery_item').removeClass('active');
    $(this).children('.product_gallery_item').addClass('active');
    $(slider)[0].swiper.slideTo(idx, 300);
  });

  //product_gallery_thumbnails — initialise every thumbnail strip
  document.querySelectorAll('.product_gallery_thumbnails').forEach(function(el){
    new Swiper(el, { slidesPerView: 4, spaceBetween: 20, observer: true, observeParents: true });
  });

  //data-show-complete-team
  $(document).on('click', '[data-show-complete-team]', function(event){
    $('.d-none.toggle_item').removeClass('d-none');
    $(this).closest('.row').addClass('d-none');
  });

  if (typeof variants != 'undefined' && $('[data-image]').length > 0) {
    var variation_image_arr = {};
    $.each(variants, function(idx, variation_data){
      // Bundle/multi-option variants often have no per-variant image — guard so a
      // null featured_image can't throw and kill every handler registered below.
      if (variation_data.featured_image && variation_data.featured_image.src) {
        variation_image_arr[variation_data.option1] = variation_data.featured_image.src;
      }
    });

    $('[data-image]').each(function(idx, varition_key){
      var key = $(this).data('image');
      // Skip swatch thumbnails
      if ($(this).closest('.radio_image').length > 0) return;
      if (variation_image_arr[key]) $(this).attr('src', variation_image_arr[key]);
    });
  }

  //product_featured_item
  $(document).on('click', '.product_featured_item', function(event){
    $('.product_featured_item').removeClass('active');
    $(this).addClass('active');
  });  

  //qty_plus
  $(document).on('click', '.product_qty_plus', function(event){
    var input = $(this).closest('.qty_wrapper').find('input'),
        v = $(input).val(),
        max = $(input).attr('max');

    max = typeof max != 'undefined' ? max : 10;
    v++;

    if(v >= max) return;

    $(input).val(v).change();
  });
  
  $(document).on('click', '.product_qty_minus', function(event){
    var input = $(this).closest('.qty_wrapper').find('input'),
        v = $(input).val(),
        min = 1;

    v--;

    if(v < min) return;

    $(input).val(v).change();
  });

  //cart_qty_button
  $(document).on('click', '.cart_qty_button, .remove_button', function(event){
    $('.cart__footer').addClass('loading');
    
    setTimeout(()=>{
      var total = 0;
      $('[data-item-total]').each(function(idx, el){
        var price = $(this).data('item-total');
        total = currency(total).add(price);
      });
      
      $('.totals__total-value').text(currency(total).format() +' USD');
      $('.cart__footer').removeClass('loading');
    }, 1000);
  });
  
  //data-active-bullet
  $(document).on('click', '[data-active-bullet]', function(event){
    $('.featured_bullet').removeClass('active');
    var bullet = $(this).data('active-bullet');
    $('.product_features_center_image').addClass('bullet_is_active');
    $('[data-bullet="'+ bullet +'"]').addClass('active');
  }); 

  //data-variation-idx (multi-option aware select / unselect)
  var initialPriceHtml = $('#product_price').html();

  function galleryKey(val){
    return String(val).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function showVariantGallery(key){
    var g = document.getElementById('gallery_variant_' + key);
    if (!g) return; // no per-value gallery (e.g. bundles) — leave the gallery as-is
    $('.variant_gallery_main').hide();
    $(g).fadeIn(function(){ if (this.swiper) this.swiper.update(); });
    $('.variant_gallery').hide();
    $('#thumbs_variant_' + key).fadeIn(function(){ if (this.swiper) this.swiper.update(); });
    $('#thumbs_variant_' + key + ' .product_gallery_item').removeClass('active');
    $('#thumbs_variant_' + key).find('[data-thumb="0"]').children('.product_gallery_item').addClass('active');
    if (g.swiper) g.swiper.slideTo(0, 0);
  }

  function showAllImagesGallery(){
    if (!document.getElementById('gallery_variant_')) return;
    $('.variant_gallery_main').hide();
    $('#gallery_variant_').fadeIn(function(){ if (this.swiper) this.swiper.update(); });
    $('.variant_gallery').hide();
    $('#thumbs_variant_').fadeIn(function(){ if (this.swiper) this.swiper.update(); });
  }

  function gateCart(){
    $('#product_id').val('').change();
    $('.pdp_add_to_cart').prop('disabled', true);
    $('.select_variant_hint').show();
    setNotifyVisible(false);
    setCartVisible(true);
    if (typeof initialPriceHtml !== 'undefined') $('#product_price').html(initialPriceHtml);
  }

  // Reveal the back-in-stock block only when the SELECTED variant is sold out.
  // Klaviyo's onsite script reads the variant from #product_id, so that input
  // stays populated for sold-out variants - the disabled button gates purchase.
  function setNotifyVisible(show){
    $('[data-availability-notification]').prop('hidden', !show);
  }

  // A sold-out variant hides the whole purchase row - Add to Cart and the quantity
  // stepper - rather than showing it greyed out. A disabled cart button is what
  // made customers think the item was purchasable in the first place, and picking
  // a quantity of something you cannot buy is meaningless. The back-in-stock form
  // takes its place. Incomplete / unmatched selections keep the row visible but
  // disabled, because there the customer still has a choice to make.
  function setCartVisible(show){
    // Scoped to the PDP purchase row - the cart drawer renders its own quantity
    // controls later, and they must never be caught by this.
    // Uses a class rather than .hide(): .qty_wrapper also carries Bootstrap's
    // .d-flex (display:flex !important), which beats jQuery's inline display:none.
    $('.pdp_add_to_cart, .product_main_buttons .qty_wrapper')
      .toggleClass('pdp_hidden', !show);
  }

  // Keep ?variant= in sync so the variant is unambiguous to Klaviyo, Shopify
  // analytics, and anyone who copies the URL.
  function syncVariantParam(id){
    if (!window.history || !history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      if (id) { url.searchParams.set('variant', id); }
      else { url.searchParams.delete('variant'); }
      history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  // Requires EVERY option group to have a selection, then resolves the actual
  // variant by matching option values (works for 1+ option products; tolerates
  // legacy "Name:key" option values by comparing the pre-colon part).
  var hintDefaultText = $('.select_variant_hint').first().text();

  function variantOptionValue(v, idx){
    var raw = (v.options && v.options[idx] !== undefined) ? v.options[idx] : v['option' + (idx + 1)];
    return String(raw == null ? '' : raw).split(':')[0];
  }

  function setHint(text, soldout){
    $('.select_variant_hint')
      .text(text)
      .toggleClass('select_variant_hint--soldout', !!soldout)
      .show();
  }

  // Grey out any swatch that cannot produce an in-stock variant given the other
  // options currently chosen. Reads Shopify inventory only - no manual flagging.
  function refreshSwatchAvailability(sel){
    $('.product_form_field').each(function(gi){
      $(this).find('input[data-variation-idx]').each(function(){
        var $in = $(this), val = $in.val(), ok = false;
        $.each(variants, function(i, v){
          if (!v.available) return;
          if (variantOptionValue(v, gi) !== val) return;
          for (var j = 0; j < sel.length; j++){
            if (j === gi || sel[j] === null) continue;
            if (variantOptionValue(v, j) !== sel[j]) return;
          }
          ok = true; return false;
        });
        $in.attr('data-available', ok ? 'true' : 'false')
           .closest('label').toggleClass('option_swatch--soldout', !ok);
      });
    });
  }

  function evaluateSelection(){
    var groups = $('.product_form_field');
    if (!groups.length || typeof variants === 'undefined') return;

    var sel = [], complete = true;
    groups.each(function(){
      var checked = $(this).find('input[type="radio"]:checked');
      if (checked.length){ sel.push(checked.val()); }
      else { sel.push(null); complete = false; }
    });

    refreshSwatchAvailability(sel);

    if (!complete){ gateCart(); setHint(hintDefaultText, false); return; }

    var match = null;
    $.each(variants, function(i, v){
      for (var j = 0; j < sel.length; j++){
        if (variantOptionValue(v, j) !== sel[j]) return;
      }
      match = v; return false;
    });

    if (match && match.available){
      $('#product_price').html(Shopify.formatMoney(match.price));
      $('#product_id').val(match.id).change();
      $('.pdp_add_to_cart').prop('disabled', false);
      $('.select_variant_hint').hide();
      setNotifyVisible(false);
      setCartVisible(true);
      syncVariantParam(match.id);
    } else if (match){
      // Variant exists but is out of stock: show its price, block the purchase,
      // and offer the back-in-stock signup for THIS variant.
      $('#product_price').html(Shopify.formatMoney(match.price));
      $('#product_id').val(match.id).change();
      $('.pdp_add_to_cart').prop('disabled', true);
      setHint(sel.length === 1 ? sel[0] + ' is sold out.' : 'This combination is sold out.', true);
      setNotifyVisible(true);
      setCartVisible(false);
      syncVariantParam(match.id);
    } else {
      gateCart();
      setHint('That combination is not available.', true);
    }
  }

  $(document).on('click', '[data-variation-idx]', function(){
    var input = $(this);

    // Clicking the already-selected swatch clears that option only.
    if (input.data('active')){
      input.removeData('active').prop('checked', false);
      showAllImagesGallery();
      evaluateSelection();
      return;
    }

    // Mark active within THIS option group only.
    input.closest('.product_form_field').find('[data-variation-idx]').removeData('active');
    input.data('active', true).prop('checked', true);

    showVariantGallery(galleryKey(input.val()));
    evaluateSelection();
  });

  // Back-in-stock capture. Klaviyo's own onsite form never initialises on this
  // theme (its auto-injection cannot find the product form), so we post straight
  // to Klaviyo's public client-side Back In Stock API instead. No private key is
  // involved - the company id is the public Site ID, same one klaviyo.js uses.
  function bisStatus($form, msg, ok){
    $form.closest('.availability_notification').find('[data-bis-status]')
      .text(msg)
      .toggleClass('availability_notification_status--ok', !!ok)
      .toggleClass('availability_notification_status--err', !ok)
      .prop('hidden', false);
  }

  $(document).on('submit', '[data-bis-form]', function(event){
    event.preventDefault();

    var $form = $(this),
        $btn = $form.find('button[type="submit"]'),
        $input = $form.find('input[type="email"]'),
        email = $.trim($input.val()),
        companyId = $form.data('company-id'),
        variantId = $.trim($('#product_id').val());

    if (!email || email.indexOf('@') === -1){
      bisStatus($form, 'Please enter a valid email address.', false);
      $input.focus();
      return;
    }
    // #product_id holds the resolved variant even when it is sold out - that is
    // why evaluateSelection() no longer blanks it.
    if (!variantId){
      bisStatus($form, 'Please select a colorway first.', false);
      return;
    }

    var original = $btn.text();
    $btn.prop('disabled', true).text('Adding...');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    }).then(function(res){
      if (res.status === 202 || res.ok){
        $form.hide();
        bisStatus($form, "You're on the list. We'll email you the moment it's back.", true);
      } else {
        $btn.prop('disabled', false).text(original);
        bisStatus($form, "Something went wrong. Please try again.", false);
      }
    }).catch(function(){
      $btn.prop('disabled', false).text(original);
      bisStatus($form, "Something went wrong. Please try again.", false);
    });
  });

  // Deep links from Klaviyo back-in-stock emails arrive as ?variant=<id>.
  // Preselect the matching swatches so the customer lands on the exact colorway
  // they waited for, with the right gallery and an armed Add to Cart.
  function preselectVariantFromUrl(){
    if (typeof variants === 'undefined' || !$('.product_form_field').length) return;

    var id;
    try { id = new URL(window.location.href).searchParams.get('variant'); } catch (e) { return; }
    if (!id) return;

    var target = null;
    $.each(variants, function(i, v){
      if (String(v.id) === String(id)) { target = v; return false; }
    });
    if (!target) return;

    var lastVal = null;
    $('.product_form_field').each(function(gi){
      var val = variantOptionValue(target, gi),
          $group = $(this),
          $in = $group.find('[data-variation-idx]').filter(function(){ return $(this).val() === val; }).first();
      if (!$in.length) return;
      $group.find('[data-variation-idx]').removeData('active');
      $in.data('active', true).prop('checked', true);
      lastVal = val;
    });

    if (lastVal !== null) showVariantGallery(galleryKey(lastVal));
    evaluateSelection();
  }

  preselectVariantFromUrl();

  //pop_video
  if ($.fn.magnificPopup) {
    $('.pop_video').magnificPopup({
      type: 'iframe'
    });

    //pop_gallery
    $('.popup_gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
        enabled: true
      }
    });
  }
  
  $(document).on('click', '.pop_gallery', function(event){
    event.preventDefault();
    var gallery_id = $(this).attr('href');
    $(gallery_id).find('a:first-child').click();    
  });

  //POP UP WINDOW
  $('.open_popup').click(function(event){
  	event.preventDefault();
  	
  	var url = $(this).attr('href') ? $(this).attr('href') : false;
  	var title = $(this).data('title') ? $(this).data('title') : '';
  	var w = $(this).data('popup-width') ? $(this).data('popup-width') : 500;
  	var h = $(this).data('popup-height') ? $(this).data('popup-height') : 400;
  	
  	var left = (screen.width / 2) - (w / 2);
  	var top = (screen.height / 2) - (h / 2);
  	
  	if(!url) return false;
  	
  	return window.open(url, title, 'toolbar=no, copyhistory=no, width='+ w +', height='+ h +', top='+ top +', left='+ left);
  });

  //accordeon_item_header
  $(document).on('click', '.accordeon_item_header', function(event){
    var item = $(this).closest('.accordeon_item'),
        body = $(item).find('.accordeon_item_body');

    if($(item).hasClass('open')){
      $(item).removeClass('open');
      $(body).slideUp();
    }else{
      $(item).addClass('open');
      $(body).slideDown();
    }
  });

  //logos-marquee-slider
  // $('.nh-logos-marquee-slider').slick({
  //   dots: false,
  //   infinite: true,
  //   slidesToShow: 6,
  //   autoplay: true,
  //   autoplaySpeed: 0,
  //   pauseOnHover: false,
  //   cssEase: 'linear',
  //   speed: 11000,
  //   arrows: false,
  //   responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 5,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 576,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });

  var window_width = $(window).width();
  const nh_testimonials_carousel = new Swiper('.nh-testimonials-carousel__swiper', {
    slidesPerView: 2.5,
    spaceBetween: 30,
    slidesOffsetBefore: window_width > 1170 ? ( $(window).width() - 1140 ) / 2 : 15,
    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 10
      },
      992: {
        slidesPerView: 2.8,
        spaceBetween: 30
      }
    }
  });

  //sub-menu-trigger
  $(document).on('click', '.sub-menu-trigger', function(event){
    event.preventDefault();

    var li_parent = $(this).closest('li');
    var submenu = li_parent.find('.sub-menu');

    if(li_parent.hasClass('active')){
      li_parent.removeClass('active');
      submenu.slideUp();
    }else{
      li_parent.addClass('active');
      submenu.slideDown();
    }
  });

  // Dynamic Yotpo reviews count -> updates .rating_count_text
  // Tries to read text like "Based on 81 reviews" from .yotpo-bottom-line-basic-text
  // and writes "(81 Reviews)" into .rating_count_text
  function setRatingCountFromYotpo(){
    var $yotpoText = $('.yotpo-bottom-line-basic-text');
    if ($yotpoText.length === 0) return false;

    var rawText = $.trim($yotpoText.text());
    // Prefer patterns like "81 review(s)", fallback to first number found
    var match = rawText.match(/(\d+)\s+review/i) || rawText.match(/(\d+)/);
    if (!match || !match[1]) return false;

    var count = match[1];
    var $target = $('.rating_count_text');
    if ($target.length === 0) return false;

    $target.text('(' + count + ' Reviews)');
    return true;
  }

  // Dynamic Yotpo rating score -> updates .rating_count_value
  // Reads number like "4.8" from .yotpo-bottom-line-score and writes into .rating_count_value
  function setRatingScoreFromYotpo(){
    var $scoreEl = $('.yotpo-bottom-line-score');
    if ($scoreEl.length === 0) return false;

    var rawText = $.trim($scoreEl.text());
    var match = rawText.match(/\d+(?:\.\d+)?/);
    if (!match || !match[0]) return false;

    var score = match[0];
    var $target = $('.rating_count_value');
    if ($target.length === 0) return false;

    $target.text(score);
    return true;
  }

  // Run immediately and then poll briefly to handle async Yotpo render
  var yotpoCountDone = setRatingCountFromYotpo();
  var yotpoScoreDone = setRatingScoreFromYotpo();
  var yotpoTries = 0;
  var yotpoMaxTries = 40; // ~10s at 250ms
  var yotpoInterval = setInterval(function(){
    var countDone = yotpoCountDone || setRatingCountFromYotpo();
    var scoreDone = yotpoScoreDone || setRatingScoreFromYotpo();
    yotpoCountDone = countDone;
    yotpoScoreDone = scoreDone;
    yotpoTries++;
    if ((countDone && scoreDone) || yotpoTries >= yotpoMaxTries) {
      clearInterval(yotpoInterval);
    }
  }, 250);
});